import { STEPS, TRACKING_STATUS } from '@constant/steps';
import { useCurrentStep } from '@context/MainContext';
import { TransferDetailsContext } from '@context/TransferDetailsContext';
import { formatDateWithSlash } from '@helpers/Date';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import { addDays } from 'date-fns';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

const TransferStatusBanner = () => {
	const theme = useTheme();
	const { t } = useTranslation();
	const currentStep = useCurrentStep();
	const { title, subtitle, icon } = TRACKING_STATUS[currentStep];
	const { timeline }: any = useContext(TransferDetailsContext);

	return (
		<>
			<Grid container direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'center' }} pb={{ xs: '24px' }}>
				<Grid item>
					<Box component="img" src={icon} />
				</Grid>
				<Grid item>
					<Grid
						container
						alignItems={{ xs: 'center', sm: 'flex-start' }}
						direction={{ xs: 'column' }}
						pt={{ xs: '24px', sm: '0px' }}
						pl={{ sm: '24px' }}>
						<Grid item>
							<Typography variant="h4" color={theme.text.primary}>
								{t(title)}
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="h6" color={theme.text.secondary}>
								{t(subtitle)} {currentStep === STEPS.IN_TRANSIT && timeline && formatDateWithSlash(addDays(new Date(timeline[0].timestamp), 2))}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default TransferStatusBanner;
